export default {
    data() {
        return {
            device: 'pc'
        }
    },
    
    methods: {
        searchMediaQuery: function(mql) {
            if (mql.matches) {
                this.device = 'sp'
            } else {
                this.device = 'pc'
            }
        }
    },
    
    mounted: function() {
        const mql = window.matchMedia('(max-width: 980px)')
        
        this.$nextTick(() => {
            try {
                // Chrom & Firefox
                mql.addEventListener("change", (e) => {
                    this.searchMediaQuery(e)
                });
            } catch (e1) {
                try {
                    // Safari
                    mql.addListener((e) => {
                        this.searchMediaQuery(e)
                    });
                } catch (e2) {
                    console.log(e1, 'first')
                    console.log(e2, 'second')
                }
            }
            
            this.searchMediaQuery(mql)
        })
    }
}